import { render, staticRenderFns } from "./MenuAdmin.vue?vue&type=template&id=407536fa&scoped=true&lang=pug&"
import script from "./MenuAdmin.vue?vue&type=script&lang=js&"
export * from "./MenuAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MenuAdmin.vue?vue&type=style&index=0&id=407536fa&scoped=true&lang=css&"
import style1 from "./MenuAdmin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407536fa",
  null
  
)

export default component.exports